import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Home from '@/views/Home'
const Templates = resolve => require(['@/views/Templates'], resolve) // [优化] 路由按需加载
const Case = resolve => require(['@/views/case'], resolve) // [优化] 路由按需加载（修正大小写，兼容 Linux 构建）
const Service = resolve => require(['@/views/Service'], resolve) // [优化] 路由按需加载
const Preview = resolve => require(['@/views/Preview'], resolve) // [优化] 路由按需加载
const News = resolve => require(['@/views/News'], resolve) // [优化] 路由按需加载
const NewsDetail = resolve => require(['@/views/NewsDetail'], resolve) // [优化] 路由按需加载
const Login = resolve => require(['@/views/Login'], resolve) // [优化] 路由按需加载
const Register = resolve => require(['@/views/Register'], resolve) // [优化] 路由按需加载
const User = resolve => require(['@/views/user'], resolve) // [优化] 路由按需加载（修正大小写，兼容 Linux 构建）
import uhiddenUtil from '@/utils/uhiddenUtil';
// import Error404 from '@/components/Error404'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'cur',
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    { path: '/', component: Home },
    { path: '/templates', component: Templates },
    { path: '/case', component: Case },
    { path: '/service', component: Service },
    { path: '/preview', component: Preview },
    { path: '/news', component: News },
    { path: '/newsDetail', component: NewsDetail },
    { path: '/login', component: Login },
    { path: '/register', component: Register },
    { path: '/user', component: User, meta: { requiresAuth: true } },
    { path: '*', component: Home }
  ]
})

// 等待 init.aspx 就绪：window.sysloginume 为 undefined 表示 init.aspx（异步脚本）尚未执行完成，
// 此时不应做登录态判定，否则强刷 /user 时会因 init.aspx 晚于应用启动而被误跳到登录页。
// 就绪后取值："" = 未登录，用户名字符串 = 已登录；超时（如 init.aspx 请求失败）按未登录处理。
const waitLoginumeReady = (timeout = 3000, interval = 100) => {
  return new Promise(resolve => {
    if (typeof window.sysloginume !== 'undefined') { resolve(); return; }
    const start = Date.now();
    const timer = setInterval(() => {
      if (typeof window.sysloginume !== 'undefined' || Date.now() - start >= timeout) {
        clearInterval(timer);
        resolve();
      }
    }, interval);
  });
};

// 路由守卫
router.beforeEach(async (to, from, next) => {
  $('body').removeClass('navOpen');

  //var systemSiteCookieId=uhiddenUtil.getSystemSiteCookieId();
  //var clientSiteCookieId=uhiddenUtil.getClientSiteCookieId();
  
//console.info("systemSiteCookieId:"+systemSiteCookieId+",clientSiteCookieId:"+clientSiteCookieId+",getCurrentUnme:"+getCurrentUnme);
// if(getCurrentUnme){
//  if(systemSiteCookieId!=clientSiteCookieId){
//     uhiddenUtil.logotCurrentUnme();
//     getCurrentUnme="";
//     //console.info("path:"+to.path+",logotCurrentUnme");
//   }
// }
 
  

  let isrequiresAuth=to.matched.some(record => record.meta.requiresAuth);

  // 需要登录态的路由，先等 init.aspx 就绪再做登录态判定（规避异步加载竞态）
  if (isrequiresAuth) {
    await waitLoginumeReady();
  }

  // 注意：登录态必须在 init.aspx 就绪之后再读取，否则强刷时读到的仍是 undefined（竞态根源）
  var getCurrentUnme=uhiddenUtil.getCurrentUnme();

//console.info("path:"+to.path+",getCurrentUnme:"+getCurrentUnme+","+isrequiresAuth);

  if (isrequiresAuth&&!getCurrentUnme) {   
     next({path:'/login'});
  }else{
     next();
  }

  //next();

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js